import $ from 'jquery';
import 'jquery-colorbox';

const WarrantyFormLightbox = () => {
	const colorboxDefaults = {
		className: 'failedPartLightbox',
		href: function () {
			if ($(this).attr('src')) {
				return $(this).attr('src');
			} else {
				return $(this).children('img').attr('src');
			}
		},
		//transition: 'fade',
		fixed: true,
		width: 1200,
		height: 720,
		opacity: .75,
		scalePhotos: true,
		maxWidth: '95%',
		maxHeight: '95%',
		initialWidth: 500,
		initialHeight: 300,
		close: '\
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.33 16.84">\
				<path fill="#fff" d="M13.46 15.34l1.48-1.49 15.35 15.34-1.49 1.49z" transform="translate(-12.96 -13.85)"/>\
				<path fill="#fff" d="M13 29.2l15.31-15.34 1.48 1.48-15.34 15.35z" transform="translate(-12.96 -13.85)"/>\
			</svg><span>Close</span>',
		previous: '\
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 332.57 570.29">\
				<path fill="#fff" d="M332.57 47.43a19.69 19.69 0 01-5.72 13.14L102.28 285.14l224.57 224.57a18 18 0 010 26.29l-28.57 28.57a18 18 0 01-26.28 0L5.71 298.29a18 18 0 010-26.29L272 5.71a18 18 0 0126.28 0l28.57 28.57a18.61 18.61 0 015.72 13.15z"/>\
			</svg>\
			<span>prev</span>',
		next: '\
			<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 332.57 570.28">\
				<path fill="#fff" d="M332.57 285.14a19.75 19.75 0 01-5.71 13.15L60.57 564.57a19.69 19.69 0 01-13.14 5.72 19.71 19.71 0 01-13.15-5.72L5.71 536A18.59 18.59 0 010 522.86a19.72 19.72 0 015.71-13.14l224.57-224.57L5.71 60.57a18 18 0 010-26.28L34.28 5.72A19.71 19.71 0 0147.43 0a19.69 19.69 0 0113.14 5.72L326.86 272a19.73 19.73 0 015.71 13.15z" />\
			</svg>\
			<span>next</span>'
	}

	$('.gform-field-label__image-wrap').each(function(index) {
		var groupName = 'group' + index;

		const colorboxConfig = jQuery.extend({}, colorboxDefaults, {
			rel: groupName
		});

		var $firstLightboxImage = $(this).find('.gform-field-label__image');
		var $additionalLightboxImages = $(this).siblings('.gform-field-label__carousel-image');

		$firstLightboxImage.attr('data-group', groupName);

		$additionalLightboxImages.attr('data-group', groupName);

		$(this).colorbox(colorboxConfig);

		$additionalLightboxImages.colorbox(colorboxConfig);
	});
};

export default WarrantyFormLightbox;